import React, { FC, useState } from 'react';
import Image from 'react-bootstrap/Image';
import styles from './ImageUploader.module.css';
import { Col, Container, Row } from 'react-bootstrap';
import { CameraIcon } from '../../../assets/icons/svg';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface ImageUploaderProp {
  setImage: (dataUrl: string) => void;
  id: string;
  imageSrc?: string | null;
  setImageMeta?: (imageMeta: ImageMeta) => void;
}

const ImageUploader: FC<ImageUploaderProp> = ({
  setImage,
  id,
  imageSrc,
  setImageMeta,
}) => {
  const [localImage, setLocalImage] = useState<string | undefined | null>(
    imageSrc
  );
  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const file = event.target.files?.[0];
    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result;

      if (dataUrl) {
        setImage(dataUrl as string);
        setImageMeta &&
          setImageMeta({
            imageSrc: file?.name ?? '',
            imageType: file?.type,
          });
        const blob = new Blob([dataUrl!]);
        const url = URL.createObjectURL(blob);
        setLocalImage(url);
      }
    };

    file && reader.readAsArrayBuffer(file);
  };
  return (
    <>
      <label htmlFor={`fileInput${id}`}>
        <Container>
          <Row className="justify-content-center">
            <Col className={styles.imageContainer}>
              <Image src={localImage ? localImage : undefined} fluid />
              <input
                type="file"
                id={`fileInput${id}`}
                style={{ display: 'none' }}
                accept="image/png, image/jpeg, image/jpg, image/webp"
                onChange={(e) => {
                  handleFileInputChange(e);
                }}
              />
              <div className={styles.uploadButton}>
                <CameraIcon />
                <div>Upload</div>
              </div>
            </Col>
          </Row>
        </Container>
      </label>
    </>
  );
};

export default ImageUploader;
